const redirectGuard = (meta) => meta.dispatch(redirectGuardAction(meta));

const redirectGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.userType === 'nonParticipant') {
		return '/home'
	}

	if (state.auth.userType === 'participant') {
		return '/dashboard'
	}

	if (state.auth.userType === 'admin') {
		return '/admin/participants'
	}

	return null
}

export { redirectGuard }
